import React, { useState, useEffect } from 'react';
import './ContactModal.css';

const ContactModal = ({ isOpen, onClose }) => {
  const [activeTab, setActiveTab] = useState('calendly');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [file, setFile] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');

  // Charger le script Calendly dès le montage du composant
  useEffect(() => {
    // Charger le script Calendly s'il n'existe pas déjà
    if (!document.querySelector('script[src="https://assets.calendly.com/assets/external/widget.js"]')) {
      const script = document.createElement('script');
      script.src = 'https://assets.calendly.com/assets/external/widget.js';
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  useEffect(() => {
    if (isOpen) {
      // Fonctions de conversion Google Ads
      window.gtag_report_conversion = function(url) {
        var callback = function () {
          if (typeof(url) != 'undefined') {
            window.location = url;
          }
        };
        window.gtag('event', 'conversion', {
          'send_to': 'AW-17802361030/CBM0CO6ziegbEMbx6ahC',
          'event_callback': callback
        });
        return false;
      };

      window.gtag_report_conversion_devis = function(url) {
        var callback = function () {
          if (typeof(url) != 'undefined') {
            window.location = url;
          }
        };
        window.gtag('event', 'conversion', {
          'send_to': 'AW-17802361030/Zdb5CJWu_ucbEMbx6ahC',
          'event_callback': callback
        });
        return false;
      };

      // Écouter les événements Calendly
      const calendlyEventListener = (e) => {
        if (e.data.event && e.data.event === 'calendly.event_scheduled') {
          console.log('Événement Calendly planifié');
          if (window.gtag_report_conversion) {
            window.gtag_report_conversion();
          }
          if (window.lintrk) {
            window.lintrk('track', { conversion_id: 25396306 });
          }
        }
      };

      window.addEventListener('message', calendlyEventListener);

      return () => {
        window.removeEventListener('message', calendlyEventListener);
      };
    }
  }, [isOpen]);

  // Réinitialiser le widget Calendly quand l'onglet change
  useEffect(() => {
    if (activeTab === 'calendly' && window.Calendly) {
      setTimeout(() => {
        const widget = document.querySelector('.calendly-inline-widget');
        if (widget) {
          widget.innerHTML = '';
          window.Calendly.initInlineWidget({
            url: 'https://calendly.com/alix-caperan/new-meeting',
            parentElement: widget
          });
        }
      }, 100);
    }
  }, [activeTab]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('');

    try {
      const formData = new FormData();
      formData.append('email', email);
      formData.append('message', message);
      if (file) {
        formData.append('file', file);
      }

      const response = await fetch('https://myaidgent.com/send-email.php', {
        method: 'POST',
        body: formData,
      });

      if (response.ok) {
        setSubmitStatus('success');
        setEmail('');
        setMessage('');
        setFile(null);
        
        console.log('Formulaire soumis - Demande de devis (4)');
        if (window.gtag_report_conversion_devis) {
          window.gtag_report_conversion_devis();
        }
        if (window.lintrk) {
          window.lintrk('track', { conversion_id: 25396314 });
        }
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      console.error('Erreur lors de l\'envoi:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile && selectedFile.size > 10 * 1024 * 1024) {
      alert('Le fichier est trop volumineux. Maximum 10 Mo.');
      return;
    }
    setFile(selectedFile);
  };

  return (
    <div className={`modal-overlay ${isOpen ? 'visible' : 'hidden'}`} onClick={onClose}>
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>×</button>
        
        <div className="modal-tabs">
          <button
            className={`modal-tab ${activeTab === 'calendly' ? 'active' : ''}`}
            onClick={() => setActiveTab('calendly')}
          >
            Prendre rendez-vous
          </button>
          <button
            className={`modal-tab ${activeTab === 'devis' ? 'active' : ''}`}
            onClick={() => setActiveTab('devis')}
          >
            Demande de devis
          </button>
        </div>

        <div className="modal-content">
          {activeTab === 'calendly' ? (
            <div className="calendly-container">
              <div
                className="calendly-inline-widget"
                data-url="https://calendly.com/alix-caperan/new-meeting"
                style={{ minWidth: '320px', height: '700px' }}
              ></div>
            </div>
          ) : (
            <div className="devis-container">
              <form onSubmit={handleSubmit} className="devis-form">
                <div className="form-group">
                  <label htmlFor="email">Email *</label>
                  <input
                    type="email"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    placeholder="votre@email.com"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="message">Description du projet *</label>
                  <textarea
                    id="message"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    required
                    rows="6"
                    placeholder="Décrivez votre projet, vos besoins et vos objectifs..."
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="file">Document (optionnel, max 10 Mo)</label>
                  <input
                    type="file"
                    id="file"
                    onChange={handleFileChange}
                    accept=".pdf,.doc,.docx,.txt"
                  />
                  {file && <p className="file-name">{file.name}</p>}
                </div>

                <button
                  type="submit"
                  className="submit-button"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Envoi en cours...' : 'Envoyer la demande'}
                </button>

                {submitStatus === 'success' && (
                  <p className="success-message">Votre demande a été envoyée avec succès !</p>
                )}
                {submitStatus === 'error' && (
                  <p className="error-message">Une erreur est survenue. Veuillez réessayer.</p>
                )}
              </form>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContactModal;
